import React from 'react';
import { Grid, TextField, Typography, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SimpleMenu } from 'components';
import { useEvents } from 'hooks';

const PlantFieldInput = () => {
  const { t } = useTranslation();
  const { setPlan, farmerPlan } = useEvents();

  const handleYieldChange = (event) => {
    setPlan({ data: { ...farmerPlan.data, yield: event.target.value } });
  };

  const handleCropChange = (event) => {
    setPlan({ data: { ...farmerPlan.data, crop: event.target.value } });
  };

  const handleYieldUnitsChange = (units) => {
    setPlan({ data: { ...farmerPlan.data, yield_units: units } });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('plant_information')}</Typography>
      </CardContent>
      <Grid container>
        <Grid item xs={12} sm={4} padding={2} alignItems="center">
          <TextField
            id="crop"
            label={t('crop')}
            value={farmerPlan?.data?.crop}
            placeholder="e.g Corn"
            onChange={handleCropChange}
          />
        </Grid>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="yield"
              label={t('yield_exp')}
              value={farmerPlan?.data?.yield}
              placeholder="0"
              onChange={handleYieldChange}
              type="number"
            />
          </Grid>
          <Grid item sm={2}>
            <SimpleMenu
              placeholder={t('yield_units')}
              menuItems={['bushels', 'tons', 'lb/ac']}
              selectedItem={farmerPlan?.data?.yield_units}
              selectItem={handleYieldUnitsChange}
              size="normal"
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default PlantFieldInput;
